import {createRoot} from "react-dom/client";
import React, {useEffect, useRef, useState} from "react";
import axios from "axios";
import PaginationControl from "./PaginationControl";
import {Modal} from "bootstrap";
import getTaxonLabel from "./SelectTaxa";
import ErrorDisplay from "./ErrorDisplay";
const apiRoot = process.env.MIX_API_ROOT;

const initSelectCollectors = targetId => {
    const selectCollectorsContainer = document.getElementById(targetId);
    if(selectCollectorsContainer) {
        const errorStatus = selectCollectorsContainer.attributes.error.value;
        const errorMessage = selectCollectorsContainer.attributes['error-message'].value;
        const collectors = JSON.parse(selectCollectorsContainer.attributes['collectors'].value);

        const selectCollectorsRoot = createRoot(selectCollectorsContainer);
        selectCollectorsRoot.render(<SelectCollectors
            error={errorStatus}
            errorMessage={errorMessage}
            selectedCollectors={collectors}
        />);
    }
}

export default function SelectCollectors(props) {

    const [selectedCollectors,setSelectedCollectors] = useState(props.selectedCollectors);
    const [collectors,setCollectors] = useState([]);
    const [collectorsLoading,setCollectorsLoading] = useState(true);
    const [showAddCollector, setShowAddCollector] = useState(false);

    const refreshList = () => {
        const url = apiRoot + '/collectors';
        setCollectorsLoading(true);
        axios
            .get(url)
            .then((response) => {
                setCollectors(response.data);
                setCollectorsLoading(false);
            })

    }

    useEffect(()=>{
        refreshList();
    },[]);

    const removeCollector = (collector) => {
        let newCollectorSet = [];
        selectedCollectors.forEach(existingCollector => {
            if(collector.id !== existingCollector.id)
            {
                newCollectorSet.push(existingCollector);
            }
        })
        setSelectedCollectors(newCollectorSet);
    }

    const handleCollectorSelection = newCollector => {
        if(! selectedCollectors.some(collector => collector.id === newCollector.id))
        {
            setSelectedCollectors(selectedCollectors => [...selectedCollectors,newCollector]);
        }
    }

    return (
        <>
            <div className='row'>
                <div className='form-label'>Collectors</div>
            </div>
            <div className="row">
                <div className="col-auto">
                    <CollectorButtons collectors={selectedCollectors} removeCollector={removeCollector}/>
                </div>
                <div className="col-auto ms-auto">
                    <button className={`btn btn-primary ${collectorsLoading ? 'disabled' : '' }`}
                            type="button"
                            onClick={e=>{
                        e.preventDefault();
                        setShowAddCollector(true);
                    }}>
                        { collectorsLoading ? 'Loading Collectors' :  'Add Collector' }
                    </button>
                </div>
            </div>
            <CollectorSelectionModal
                collectors={collectors}
                showAddCollector={showAddCollector}
                setShowAddCollector={setShowAddCollector}
                handleCollectorSelection={handleCollectorSelection}
                refreshList={refreshList}
                collectorsLoading={collectorsLoading}
            />
            <HiddenCollectorInputs selectedCollectors={selectedCollectors} error={props.error} />
            <ErrorDisplay {...props} />
        </>
    );
}

const HiddenCollectorInputs = (props) => {
    let hiddenInputClass = '';
    if(props.error === 'valid') {
        hiddenInputClass = 'is-valid';
    } else if (props.error === 'yes'){
        hiddenInputClass = 'is-invalid'
    }
    if(props.selectedCollectors.length === 0)
    {
        return (
            <input className={hiddenInputClass} name={'collector-ids'} key={'none'} type={'hidden'} value=""></input>
        );
    }
    const hiddenCollectorIdInputs = props.selectedCollectors.map(collector => {
        return (
            <input className={hiddenInputClass} name={'collector-ids[]'} key={collector.id} type={'hidden'} value={collector.id} />
        );
    })
    return <>
        {hiddenCollectorIdInputs}
    </>
}

const CollectorButtons = (props) => {
    if(props.collectors !== undefined)
    {
        const buttons = props.collectors.map(collector => {
            return <CollectorButton key={collector.id} collector={collector} removeCollector={props.removeCollector} />
        })
        return (<>
            {buttons}
        </>);
    }
    return null;
}

const CollectorButton = (props) => {
    return (
        <div className={'btn-group me-1 mb-1'}>
            <div className={'btn btn-outline-dark disabled'}>
                <strong>
                    { props.collector.display_name }
                </strong>
            </div>
            <button
                className={'btn btn-dark'}
                type="button"
                onClick={ e => {
                    e.preventDefault();
                    props.removeCollector(props.collector)
                }}
            >
                {String.fromCharCode(215)}
            </button>
        </div>
    );
}

const CollectorSelectionModal = (props) => {
    const pageSize = 20;
    const [page,setPage] = useState(1);
    const [myModal,setMyModal] = useState(undefined);
    const [collectorFocusDefault,setCollectorFocusDefault] = useState(-1);
    const collectorNameRef = useRef(null);
    const modalRef = useRef(null);
    const listRef = useRef(null);
    useEffect(()=>{
        if(modalRef.current !== null) {
            setMyModal(new Modal(modalRef.current));
            modalRef.current.addEventListener('hidden.bs.modal', event => {
                props.setShowAddCollector(false);
            })
            modalRef.current.addEventListener('shown.bs.modal', event => {
                collectorNameRef.current.focus();
            })
        }
    },[])
    useEffect(()=>{
        if(myModal !== undefined)
        {
            if(props.showAddCollector)
            {
                myModal.show();
            } else {
                myModal.hide();
            }
        }
    },[props.showAddCollector]);

    let focusedCollector = collectorFocusDefault;

    const handleKeypress = (e)=>{
        if(e !== undefined && props.showAddCollector){
            if(e.key === "ArrowUp" || e.key === "ArrowDown") {
                let numberOfPages = Math.trunc(possibleCollectors.length / pageSize);
                e.preventDefault();
                if(e.key === "ArrowUp" ){
                    if(focusedCollector > 0) {
                        focusedCollector--;
                    } else {
                        if(page > 1 ) {
                            setPage(page - 1);
                            setCollectorFocusDefault(pageSize);
                            return;
                        } else {
                            focusedCollector = -1;
                            collectorNameRef.current.focus();
                            return;
                        }
                    }
                } else if(e.key === "ArrowDown") {
                    if(focusedCollector < listRef.current.children.length - 1 ) {
                        focusedCollector++;
                    } else if(page <= numberOfPages) {
                        setPage(page+1)
                        focusedCollector = -1;
                        setCollectorFocusDefault(-1);
                        collectorNameRef.current.focus();
                        return;
                    }
                }
                if(focusedCollector >= 0 && focusedCollector < listRef.current.children.length) {
                    listRef.current.children[focusedCollector].focus()
                }
            }

        }
    };
    useEffect(() => {
        document.addEventListener("keydown",handleKeypress,false);
        return () => {
            document.removeEventListener("keydown",handleKeypress, false)
        }
    }, [handleKeypress]);

    const [collectorName,setCollectorName] = useState('');
    useEffect(()=>{
        setPage(1);
    },[collectorName])

    const handleCollectorNameChange = e => {
        setCollectorName(e.target.value)
    }

    const openNewCollector = () => {
        let openurl = '/collectors/create';
        window.open(openurl, '_blank');
    }

    let possibleCollectors = [];
    if(props.collectors !== undefined && props.collectors !== null) {
        props.collectors.forEach(collector => {
            if(collector.display_name.toLowerCase().includes(collectorName.toLowerCase())) {
                possibleCollectors.push(collector)
            }
        });
    }

    let collectorItems = [];
    if(possibleCollectors.length > 0){
        collectorItems = possibleCollectors.map((collector) =>
            <button
                key={collector.id}
                className={'list-group-item list-group-item-action'}
                onClick={event => {
                    event.preventDefault();
                    props.handleCollectorSelection(collector);
                    setCollectorName('');
                    myModal.hide();
                }}
                type="button"

            >
                {collector.display_name}
            </button>
        );
    }


    collectorItems = collectorItems.slice((page -1) * pageSize, page * pageSize);

    return (
        <div ref={modalRef} className="modal fade" id="addCollectorModel" tabIndex="-1" aria-labelledby="addCollectorModelLabel">
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="addCollectorModelLabel">Add Collector</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    {
                        props.collectorsLoading ?
                            <div className="modal-body p-5 align-content-center text-center">
                                Loading Collectors...
                            </div>
                        : (
                        <>
                            <div className="modal-body">
                                <label htmlFor={'collector-name'} className={'form-label'}>Search Collectors</label>
                                <input ref={collectorNameRef} id={'collector-name'} className={'form-control'} value={collectorName} onChange={handleCollectorNameChange} />
                                <div className={'list-group mt-3'} ref={listRef}>
                                    {collectorItems}
                                </div>
                                <PaginationControl
                                    className={'pt-3'}
                                    total={possibleCollectors.length}
                                    pageSize={pageSize}
                                    setPage={setPage}
                                    currentPage={page}
                                />
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={openNewCollector}
                                >
                                    Add New
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={props.refreshList}
                                >
                                    Refresh
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                >
                                    Cancel
                                </button>
                            </div>
                        </>
                        )
                    }
                </div>
            </div>
        </div>
    );
}

export { initSelectCollectors }
